






















import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';
import cPopup from '@/components/default/Popup.vue';
import { CreateVolumeDiscountsCommand, DeleteVolumeDiscountsCommand, UpdateVolumeDiscountsCommand, VolumeDiscount, VolumeDiscountClient } from '@/data/web-api-client';
import notificationService from '@/services/notificationService';
import { DxLookup } from 'devextreme-vue';
import { DxColumn, DxDataGrid, DxEditing, DxStateStoring } from 'devextreme-vue/data-grid';
import { DxForm, DxGroupItem, DxItem, DxLabel, DxRequiredRule, DxSimpleItem } from 'devextreme-vue/form';
import { DxSelectBox } from 'devextreme-vue/select-box';
import dxDataGrid from 'devextreme/ui/data_grid';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    cCard,
    cDatagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxColumn,
    DxSelectBox,
    DxLookup,
  },
})
export default class VolumeDiscountsTable extends Vue {
  public volumeDiscounts!: VolumeDiscount[];

  private volumeDiscountClient = new VolumeDiscountClient(undefined, this.$axios);

  private async mounted() {
    await this.getVolumeDiscounts();
  }

  public initRow(e: any) {
    const component = e.component as dxDataGrid;
    const rows = component.getVisibleRows();

    if (rows.length == 0) {
      e.data.lowerLimit = 0;

      return;
    }

    const lastRow = component.getVisibleRows()[rows.length - 1].data as VolumeDiscount;

    e.data.lowerLimit = lastRow.upperLimit;
  }

  public addRow() {
    const table: any = this.$refs.grid;

    table.instance.addRow();
  }

  public async createRow(e: any) {
    const volumeDiscount: VolumeDiscount = e.data;

    await this.volumeDiscountClient
      .addVolumeDiscount(
        new CreateVolumeDiscountsCommand({
          lowerLimit: volumeDiscount.lowerLimit,
          upperLimit: volumeDiscount.upperLimit,
          discountPercentage: volumeDiscount.discountPercentage,
        })
      )
      .catch((error) => notificationService.failedToSave());

    this.gridInstance.cancelEditData();
    this.getVolumeDiscounts();
    notificationService.saved();
  }

  public async updateRow(e: any) {
    const volumeDiscount: VolumeDiscount = Object.assign({}, e.oldData as VolumeDiscount, e.newData);

    await this.volumeDiscountClient
      .updateVolumeDiscount(
        new UpdateVolumeDiscountsCommand({
          id: volumeDiscount.id,
          lowerLimit: volumeDiscount.lowerLimit,
          upperLimit: volumeDiscount.upperLimit,
          discountPercentage: volumeDiscount.discountPercentage,
        })
      )
      .catch((error) => notificationService.failedToSave());

    this.gridInstance.cancelEditData();
    this.getVolumeDiscounts();
    notificationService.saved();
  }

  public async deleteRow(e: any) {
    await this.volumeDiscountClient.deleteVolumeDiscount(new DeleteVolumeDiscountsCommand({ id: e.data.id }));

    this.getVolumeDiscounts();
    e.cancel = true;
  }

  private async getVolumeDiscounts() {
    await this.volumeDiscountClient
      .getAll()
      .then((volumeDiscounts) => {
        this.volumeDiscounts = volumeDiscounts;
      })
      .catch((error) => notificationService.failedToLoad());
  }

  get columns() {
    return [
      {
        dataField: 'lowerLimit',
        caption: 'Benedengrens',
      },
      {
        dataField: 'upperLimit',
        caption: 'Bovengrens',
      },
      {
        dataField: 'discountPercentage',
        caption: 'Kortingspercentage',
      },
    ];
  }

  get gridInstance(): dxDataGrid {
    return (this.$refs.grid as DxDataGrid).instance!;
  }
}
